module.exports = __webpack_public_path__ + "img/41_4.ddb7ee41.png";